// extracted by mini-css-extract-plugin
module.exports =  {"switch":"a10a3f92e9--switch--Iu4Bo","indicator":"a10a3f92e9--indicator--JD6wH","disabled":"a10a3f92e9--disabled--WS_Zh"};